export enum settledAuditStatusEnum {
  未审核 = 0,
  审核中 = 1,
  已审核 = 2,
  待认证 = 3,
  审核不通过 = 7,
}
